import DocViewShell from "@/components/DocViewShell";
import SwotBlueprint from "@/components/blueprints/SwotBlueprint";

export default function SwotView() {
  return (
    <DocViewShell
      eyebrow="SWOT Matrix"
      eyebrowClass="text-indigo-700"
      toolName="SWOT Matrix"
      editPathFn={(id) => `/swot/${id}`}
      render={(doc) => <SwotBlueprint doc={doc} />}
    />
  );
}
